import React from "react";
import SocialLinks from "./SocialLinks";

const Banner = () => (
  <div className="row banner">
    <div className="banner-text">
      <h1 className="responsive-headline">I'm Jaka Hrepevnik.</h1>
      <h3>
        5 years of experience in web projects.<br/>Focusing on automation and email marketing. <br/>
        Scroll down and 
        <a className="smoothscroll" href="#resume">
          {" "}
          learn more
        </a>.
      </h3>
      <SocialLinks />
    </div>
  </div>
);

export default Banner;



// WEBPACK FOOTER //
// ./src/components/Banner.js